import { render, staticRenderFns } from "./CustomerMatch.vue?vue&type=template&id=ab4a1134&scoped=true&"
import script from "./CustomerMatch.vue?vue&type=script&lang=js&"
export * from "./CustomerMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4a1134",
  null
  
)

export default component.exports